import {useRequest} from 'ahooks';
import {useEffect, useState} from 'react';

import Loading from '../../components/Loading';

import './style.css';

export default function Pending({}) {
  const [hash, setHash] = useState('');
  const [tradeHashStatus, setTradeHashStatus] = useState();
  const rpcAddressRequest = useRequest(
    body => ({
      url: '/blockBrowser/common/rpcAddress',
      method: 'post',
      body: JSON.stringify(body),
    }),
    {manual: true},
  );

  const pendingTradeRequest = useRequest(
    body => ({
      url: '/blockBrowser/misc/pending/pendingTrade',
      method: 'post',
      body: JSON.stringify(body),
    }),
    {manual: true},
  );

  useEffect(() => {
    rpcAddressRequest.run({});
  }, []);

  if (rpcAddressRequest.loading) {
    return <Loading />;
  }

  const {mainnet_rpc_address} = rpcAddressRequest.data || {
    mainnet_rpc_address: 'https://rpc.movachain.com',
  };

  const handleSearch = () => {
    if (!hash) {
      return;
    }

    if (hash.length !== 66) {
      return;
    }

    pendingTradeRequest
      .run({
        port_address: mainnet_rpc_address,
        trade_hash: hash,
      })
      .then(res => {
        setTradeHashStatus(res.trade_hash_status);
      });
  };

  return (
    <div className="page-pending">
      <div className="container flex-center">
        <div className="w-md-55 faucet-container">
          <div className="mb-5">
            <h1 className="text-primary font-weight">待打包交易查询工具</h1>
          </div>
          <div className="input-container input-group mb-4">
            <input placeholder="RPC端口" className="form-control" defaultValue={mainnet_rpc_address} />
          </div>
          <div className="input-container input-group">
            <input
              placeholder="请输入交易哈希"
              className="form-control input-form"
              value={hash}
              onChange={e => {
                setHash(e.target.value);
              }}
            />
            <button type="button" className="btn btn-primary btn-wide btn-input" onClick={handleSearch}>
              查询
            </button>
          </div>
          {typeof tradeHashStatus !== 'undefined' ? (
            <div className="input-container input-group">
              <div class="search-container pre" style={{width: '100%'}}>
                {!tradeHashStatus ? (
                  <>
                    <div>该交易尚未进入节点，或已被mempool规则排除。</div>
                    <a rel="noopener noreferrer" target="_blank" href="https://docs.movachain.com/#/dev/txpool" class="txpool">
                      前往链接获取解决方案
                    </a>
                  </>
                ) : (
                  <div>该交易已经进入区块链</div>
                )}
              </div>
            </div>
          ) : undefined}
        </div>
      </div>
    </div>
  );
}
